<template>
    <section class="container-card-units-customer">
        <div class="container-card-units-customer-content">
            <ui-tag-indicator :text="data.id" color="#1CCA85" />

            <div class="name-client">
                {{ data.customer?.name || '-' }}
            </div>

            <div v-if="data.customer?.cpf" class="data-client">
                CPF: {{ data.customer.cpf | documentBr }}
            </div>

            <div v-if="data.customer?.mobile || data.customer?.email" class="number-email-client">
                Celular:
                <span class="number">
                    {{ data.customer?.mobile ? (data.customer.mobile | phoneMask) : '-' }}
                </span>
                -
                E-mail:
                <div class="email">{{ data.customer?.email || '-' }}</div>
            </div>
        </div>
    </section>
</template>

<script>
    import { uiTagIndicator } from '@/components/ui/tags'

    import {  documentBr, phoneMask } from "@/filters"

    export default {
        name: 'card-units-customer',

        components: {
            uiTagIndicator
        },

        filters: {
            documentBr,
            phoneMask
        },

        props: {
            data: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>